import {Injectable} from '@angular/core';
import {PermissaoAbrangencia, PermissaoOrigem, UsuarioPermissao} from './usuario-permissao.model';
import {HttpClient} from '@angular/common/http';
import {ConsultaPaginada, ConsultaPaginadaResultado} from 'maestro-ng';
import {BaseService} from '../services/base-service.service';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class UsuarioPermissaoService extends BaseService<UsuarioPermissao, number> {

  constructor(http: HttpClient) {
    super('usuarioPermissao', http);
  }

  public newEntity(): UsuarioPermissao {
    const usuarioPermissao = {} as UsuarioPermissao;
    usuarioPermissao.abrangencia = PermissaoAbrangencia.NACIONAL;
    usuarioPermissao.vigente = true;
    usuarioPermissao.origem = PermissaoOrigem.NATIVO;
    usuarioPermissao.inicio = new Date();
    return usuarioPermissao;
  }

  public getId(entity: UsuarioPermissao): number {
    return entity.id;
  }

  public recuperarPorId(id: number): Promise<UsuarioPermissao> {
    return firstValueFrom(this.http.get<UsuarioPermissao>(this.path(`${id}`)));
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<UsuarioPermissao>> {
    return this.service.recuperarPaginado(consulta);
  }

  public salvar(usuarioPermissao: UsuarioPermissao): Promise<UsuarioPermissao> {
    return firstValueFrom(this.http.post<UsuarioPermissao>(this.path(''), usuarioPermissao, {headers: this.createJsonHttpHeaders()}));
  }

  public encerrarVigencia(usuarioPermissao: UsuarioPermissao): Promise<void> {
    return firstValueFrom(this.http.patch<void>(this.path(`encerrarVigencia/${usuarioPermissao.id}`), undefined));
  }
}
